export const SEARCH_SPOTS_FAILURE = 'SEARCH_SPOTS_FAILURE';

export const searchSpotsFailure = ( payload: Error ) => ({
    type: SEARCH_SPOTS_FAILURE,
    payload,
    error: true,
});